// extracted by mini-css-extract-plugin
module.exports = {"edit-event-button":"EditEventButton_edit-event-button__ergtc","full-width":"EditEventButton_full-width__t9VI4"};